<template>
  <section id="aboutus" class="section about">
    <div class="section-container about-grid reveal">
      <div class="about-media card">
        <img src="@/assets/about us img.png" alt="Tim Abercode" loading="lazy" decoding="async" />
      </div>

      <div class="about-content">
        <span class="section-label">Tentang Kami</span>
        <h2 class="section-title">Partner teknologi untuk pertumbuhan bisnis Anda</h2>
        <p>
          Didirikan pada tahun 2019 di Bandung,
          <strong>Abercode Software Innovation</strong> berfokus pada
          pengembangan aplikasi web, mobile, desktop, dan sistem informasi untuk
          kebutuhan bisnis maupun institusi.
        </p>
        <p>
          Misi kami adalah memudahkan manusia menggunakan teknologi inovatif
          melalui solusi yang stabil, terukur, dan relevan dengan kebutuhan masa
          depan.
        </p>
        <p>
          Dengan komitmen pada kualitas dan layanan yang konsisten, kami siap
          menjadi partner tepercaya dalam perjalanan transformasi digital Anda.
        </p>

        <div class="about-actions">
          <a href="#contactdetails" class="btn btn-accent">Hubungi Kami</a>
          <a href="#portofolio" class="btn btn-ghost">Proyek Kami</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.about {
  padding-top: 28px;
}

.about-grid {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 28px;
  align-items: center;
}

.about-media {
  overflow: hidden;
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.75);
}

.about-media img {
  width: 100%;
  height: 100%;
  min-height: 370px;
  object-fit: cover;
}

.about-content p {
  margin-top: 12px;
  font-size: 0.98rem;
}

.about-content strong {
  color: var(--primary);
}

.about-actions {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 980px) {
  .about-grid {
    grid-template-columns: 1fr;
  }

  .about-media img {
    min-height: 280px;
  }
}

@media (max-width: 640px) {
  .about-actions .btn {
    flex: 1;
    min-width: 125px;
  }
}
</style>
